module.exports = __webpack_public_path__ + "static/media/elmetape.102a89c3.png";